import { CouldNotParse } from 'components/ordering/checkout/payment-methods/payment-backend/could-not-parse.js'
import { is } from 'typia'
import { CSCMollieRiverty, type TrydentMollieRivertyData } from './mollie-riverty.js'
import { type RivertyMethodId } from 'components/ordering/checkout/payment-methods/methods/method-ids.js'


type TrydentMollieRivertyResponse = {
  custom_description: string,
  mollie_data: TrydentMollieRivertyData & { id: RivertyMethodId }
}

export const parseMollieRiverty = (value: unknown, selectedPaymentMethod: string): CSCMollieRiverty | typeof CouldNotParse => {
  if (is<TrydentMollieRivertyResponse>(value)) {
    const state = value.mollie_data.id === selectedPaymentMethod ? 'selected' : 'selectable'
    return new CSCMollieRiverty(
      value.mollie_data,
      state,
      value.custom_description,
    )
  }
  return CouldNotParse
}
